import React, {useEffect, useState, useCallback} from "react";
import {Select, Spin, Modal, Tag} from "antd";
import {Ghost, Eye} from 'lucide-react';
import useUserMaskStore from "../../store/user/userMaskStore";
import {APIv1} from "../../api";
import "./UserRoleMask.css";

const eyeIcon = <Eye size={14}/>;

const {Option} = Select;

const UserRoleMask = ({userData, onSelectChange, placeholder = "disguise oneself"}) => {
    const [loading, setLoading] = useState(false);
    const [options, setOptions] = useState([]);
    const [showEffect, setShowEffect] = useState(false);
    const [showClearEffect, setShowClearEffect] = useState(false);

    const addMask = useUserMaskStore((state) => state.addMaskedCompany);
    const maskedCompany = useUserMaskStore((state) => state.maskedCompany);
    const clearMaskedCompany = useUserMaskStore((state) => state.clearMaskedCompany);

    const fetchAllData = useCallback(async () => {
        setLoading(true);
        let allResults = [];
        let nextPage = "/company/mask/value/";

        try {
            while (nextPage) {
                const response = await APIv1.get(nextPage, {
                    headers: {Authorization: `Token ${userData.token}`},
                });

                if (response.status === 200) {
                    allResults = [...allResults, ...response.data.results];
                    nextPage = response.data.next;
                } else {
                    nextPage = null;
                }
            }

            setOptions(allResults);
        } catch (error) {
            console.error("Error fetching all data:", error);
        } finally {
            setLoading(false);
        }
    }, [userData.token]);

    useEffect(() => {
        if (options.length === 0) {
            fetchAllData();
        }
    }, [fetchAllData, options.length]);

    const handleSelectChange = (value) => {
        const selectedCompany = options.find((item) => item.name === value);

        if (selectedCompany) {
            Modal.confirm({
                title: "Confirm Role Change",
                content: `Are you sure you want to change the role to ${selectedCompany.name}?`,
                okText: "Yes",
                cancelText: "No",
                onOk: () => {
                    addMask(selectedCompany);
                    setShowEffect(true);
                    setTimeout(() => setShowEffect(false), 2000);

                    if (onSelectChange) {
                        onSelectChange(selectedCompany);
                    }
                },
            });
        }
    };

    const handleClear = () => {
        setShowClearEffect(true);

        setTimeout(() => {
            clearMaskedCompany();
            setShowClearEffect(false);
        }, 1500);

        if (onSelectChange && typeof onSelectChange === "function") {
            onSelectChange(null);
        }
    };

    return (
        <div className="user-role-mask-container">
            {maskedCompany && (
                <>
                    <div className="ghost-icon-wrapper">
                        <Ghost className="ghost-icon" size={24}/>
                    </div>
                </>
            )}

            <Select
                showSearch
                allowClear
                virtual={false}
                placeholder={placeholder}
                suffixIcon={eyeIcon}
                status="error"
                onChange={handleSelectChange}
                onClear={handleClear}
                loading={loading}
                value={maskedCompany ? maskedCompany.name : undefined}
                filterOption={(input, option) =>
                    String(option.children)?.toLowerCase()?.includes(input.toLowerCase())
                }
                styles={{
                    popup: {
                        root: {
                            width: 300,
                        },
                    },
                }}
                listHeight={400}
                style={{maxWidth: 200, flex: 1}}
            >
                {loading ? (
                    <Option disabled>
                        <Spin size="small"/>
                    </Option>
                ) : (
                    options.map((item) => (
                        <Option key={item.id} value={item.name}>
                            <Tag color="purple">{item.inn}</Tag> {item.name}
                        </Option>
                    ))
                )}
            </Select>
        </div>
    );
};

export default UserRoleMask;
